import React, { createContext, useContext, useEffect, useState } from 'react';
import { getTenantId as readPersisted, setTenantId as writePersisted } from '../api/tenantHeader.ts';

type Ctx = { tenantId: number | null; setTenantId: (id: number|null) => void };
const TenantCtx = createContext<Ctx>({ tenantId: null, setTenantId: () => {} });

export const TenantProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [tenantId, setTenantIdState] = useState<number | null>(() => readPersisted());
  useEffect(() => {
    setTenantIdState(readPersisted());
  }, []);
  const setTenantId = (id: number | null) => { setTenantIdState(id); writePersisted(id); };
  return <TenantCtx.Provider value={{ tenantId, setTenantId }}>{children}</TenantCtx.Provider>;
};

export const useTenant = () => useContext(TenantCtx);


